<script>
import Drawer from "@/components/drawer";
import Swal from "sweetalert2";
import { required } from "vuelidate/lib/validators";

// Custom components
import PageHeader from "@/components/page-header";
import UpSell from "@/components/upSell/index.vue";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Up Sell",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
    Drawer,
    UpSell,
  },
  data() {
    return {
      title: "Up Sell",
      openNewUpSellForm: false,
      isEdit: false,
      tableData: [],
      updateValueId: "",
      isDataLoading: false,
      updateDataId: "",
    };
  },
  computed: {
    ...authComputed,
    upSellFormProps() {
      return { isEdit: this.isEdit, updateValueId: this.updateValueId };
    },
  },
  mounted() {
    this.getUpSellList();
  },
  validations: {
    image: {
      required,
    },
  },
  methods: {
    // Ṃethod is use for get all upsell list
    getUpSellList() {
      this.isDataLoading = true;
      const query = "";
      UserService.getAllUpSell(query).then((response) => {
        this.tableData = response;
        this.isDataLoading = false;
      });
    },
    // Method is use for handle upsell form
    newUpSellForm() {
      if (this.openNewUpSellForm === true) {
        this.isEdit = false;
        this.updateValueId = "";
      }
      this.openNewUpSellForm = !this.openNewUpSellForm;
    },
    // Ṃethod is use for handle add and update upsell data
    upSellAddedUpdated(data, isEdit) {
      if (isEdit) {
        this.tableData = this.tableData.map((item) => {
          if (item.id === data.id) {
            item = data;
          }
          return item;
        });
      } else {
        this.tableData.push(data);
      }
      this.newUpSellForm();
    },
    // Method is used to add and continue add new upsell data
    saveAndAddNewUpSell(data) {
      this.tableData.push(data);
      this.newUpSellForm();
    },
    // Method is used to edit upsell
    editUpSell(id, index) {
      this.isEdit = true;
      this.updateValueId = id;
      this.newUpSellForm();
    },
    // Method is used to delete upsell
    deleteUpSell(id, index) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          UserService.deleteUpSell(id)
            .then((response) => {
              this.tableData.splice(index, 1);
              Middleware.notification("Successfully deleted !!", "success");
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      });
    },
    // Method is ued to change status
    changeUpSellStatus(upsell_id, data) {
      UserService.updateUpSell(upsell_id, data)
        .then(() => {
          Middleware.notification("Successfully changed !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :action="newUpSellForm"
      text="Add New UpSell"
      :isButton="true"
    />

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 mt-2">
                <div class="table-responsive mb-0" v-dragscroll>
                  <table
                    class="table table-hover mb-0"
                    ref="my-table"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="10"
                  >
                    <thead class="table-light">
                      <tr>
                        <th>Title</th>
                        <th>Short Name</th>
                        <th>Price</th>
                        <th>Period</th>
                        <th>Based On</th>
                        <th>APROOVAL Req.</th>
                        <th>Status</th>
                        <th>Premium</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody v-if="isDataLoading">
                      <tr v-for="no in 10" :key="no">
                        <td class="placeholder-glow" v-for="no in 9" :key="no">
                          <span class="placeholder w-100 placeholder-lg"></span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr v-for="(data, index) in tableData" :key="data.id">
                        <td @click="editUpSell(data.id, index)">
                          {{ data.title }}
                        </td>
                        <td @click="editUpSell(data.id, index)">
                          {{ data.short_name }}
                        </td>
                        <td @click="editUpSell(data.id, index)">
                          {{ data.price }}
                        </td>
                        <td @click="editUpSell(data.id, index)">
                          {{ data.period == "one_time" ? "One Time" : "Daily" }}
                        </td>
                        <td @click="editUpSell(data.id, index)">
                          {{
                            data.base_on == "booking"
                              ? "Booking"
                              : data.base_on == "guest"
                              ? "Guest"
                              : "Item"
                          }}
                        </td>

                        <td>
                          <div
                            class="form-check form-switch my-1"
                            slot="is_approval_required"
                          >
                            <input
                              class="form-check-input"
                              type="checkbox"
                              v-model="data.is_approval_required"
                              @change="
                                changeUpSellStatus(data.id, {
                                  is_approval_required:
                                    data.is_approval_required,
                                })
                              "
                            />
                          </div>
                        </td>
                        <td>
                          <div
                            class="form-check form-switch my-1"
                            slot="is_active"
                          >
                            <input
                              class="form-check-input"
                              type="checkbox"
                              v-model="data.is_active"
                              @change="
                                changeUpSellStatus(data.id, {
                                  is_active: data.is_active,
                                })
                              "
                            />
                          </div>
                        </td>
                        <td>
                          <div
                            class="form-check form-switch my-1"
                            slot="is_active"
                          >
                            <input
                              class="form-check-input"
                              type="checkbox"
                              v-model="data.is_premium_upsell"
                              @change="
                                changeUpSellStatus(data.id, {
                                  is_premium_upsell: data.is_premium_upsell,
                                })
                              "
                            />
                          </div>
                        </td>
                        <td>
                          <div slot="actions" class="d-flex align-items-center">
                            <i
                              class="fas fa-pencil-alt mx-1 text-success"
                              v-b-popover.hover="'Edit up sell'"
                              @click="editUpSell(data.id, index)"
                            ></i>
                            <i
                              v-if="data.is_deleted"
                              class="mdi mdi-trash-can mx-1 fs-5 text-danger"
                              v-b-popover.hover="'Delete Up Sell'"
                              @click="deleteUpSell(data.id, index)"
                            ></i>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-if="!isDataLoading && tableData.length == 0">
                      <tr>
                        <td colspan="9" class="text-center">
                          <img
                            src="@/assets/images/empty.svg"
                            class="img-fluid"
                            alt=""
                          />
                          <p>
                            <span class="text-secondary">No Data Found</span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Drawer is for open up sell Add/Edit -->
    <Drawer
      @close="newUpSellForm()"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="openNewUpSellForm">
        <UpSell
          :currentProps="upSellFormProps"
          @submitted="upSellAddedUpdated"
          @cancelSubmit="newUpSellForm"
          @saveAndAddNew="saveAndAddNewUpSell"
        />
      </div>
    </Drawer>
  </div>
</template>
